/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Credit Line Type
 */
export type GetCardAccountsResponseDataItemType = typeof GetCardAccountsResponseDataItemType[keyof typeof GetCardAccountsResponseDataItemType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCardAccountsResponseDataItemType = {
  'asset-link': 'asset-link',
  prepaid: 'prepaid',
  'fixed-limit': 'fixed-limit',
  simple: 'simple',
} as const;
